import { IScene } from '@/types'

/**
 * Exact route match only, unlike `matchSceneByPathname`: callers ask whether a
 * brand declares a specific page (`/my-team`), and a subpath match would let
 * an unrelated scene answer for it.
 */
export function hasSceneRoute(scenes: Record<string, IScene> | undefined, route: string): boolean {
  return Object.values(scenes ?? {}).some((scene) => scene.route === route)
}
